import { createAction, createSlice } from "@reduxjs/toolkit";
import { MERCHANT_REQUEST_STATUS, MerchantRequest, MerchantRequestQueryParams } from "../type";
import { RootState } from "store/store";

export const initialMerchantRequest = {
	id: "",
	merchant: {
		id: 0,
		fullName: "",
		phoneNumber: "",
	},
	staff: {
		id: 0,
		fullName: "",
		phoneNumber: "",
	},
	type: "",
	status: MERCHANT_REQUEST_STATUS.WAIT_LIST,
	createdAt: "",
	merchantNote: "",
	staffNote: "",
	name: "",
};

export const initialAddMemberQuery = {
	skip: 0,
	take: 10,
	fullName: null,
	phoneNumber: null,
	email: null,
};

export interface MerchantRequestState {
	merchantRequestList: MerchantRequest[];
	merchantRequestDetail: MerchantRequest;
	merchantRequestTotal: number;
}

const initialState: MerchantRequestState = {
	merchantRequestList: [],
	merchantRequestDetail: initialMerchantRequest,
	merchantRequestTotal: 0,
};

export const merchantRequestSlice = createSlice({
	name: "merchantRequest",
	initialState,
	reducers: {
		setListMerchantRequest: (state, action) => {
			state.merchantRequestList = action.payload.data;
			state.merchantRequestTotal = action.payload.total;
		},
		setDetailMerchantRequest: (state, action) => {
			state.merchantRequestDetail = action.payload.data;
		},
	},
});

export const { setListMerchantRequest, setDetailMerchantRequest } =
	merchantRequestSlice.actions;

export const selectMerchantRequestList = (state: RootState) =>
	state.merchantRequest.merchantRequestList;
export const selectMerchantRequestDetail = (state: RootState) =>
	state.merchantRequest.merchantRequestDetail;
export const selectMerchantRequestTotal = (state: RootState) =>
	state.merchantRequest.merchantRequestTotal;

export interface GetListMerchantRequestPayload {
	query: MerchantRequestQueryParams;
	callback: () => void;
}

export const getListMerchantRequestAsync = createAction(
	"merchantRequest/getListMerchantRequestAsync",
	payload => ({
		payload,
	}),
);

export interface GetDetailMerchantRequestPayload {
	id: string;
	language: string;
	callback: (id: string, total: number) => void;
}

export const getDetailMerchantRequestAsync = createAction(
	"merchantRequest/getDetailMerchantRequestAsync",
	payload => ({
		payload,
	}),
);

export interface CreateMerchantRequestPayload {
	data: MerchantRequest;
	callback: () => void;
}

export const createMerchantRequestAsync = createAction(
	"merchantRequest/createMerchantRequestAsync",
	payload => ({
		payload,
	}),
);

export interface UpdateMerchantRequestPayload {
	id: string;
	callback: () => void;
	data: MerchantRequest;
}

export const updateMerchantRequestAsync = createAction(
	"merchantRequest/updateMerchantRequestAsync",
	payload => ({
		payload,
	}),
);

export interface UpdateStatusMerchantRequestPayload {
	id: string;
	callback: () => void;
	data: {
		status: string;
	};
}

export const updateStatusMerchantRequestAsync = createAction(
	"merchantRequest/updateStatusMerchantRequestAsync",
	payload => ({
		payload,
	}),
);

export default merchantRequestSlice.reducer;
